import React from 'react';

const BlueButton = ({ onClick, children, extraStyle, type }) => {
  const buttonStyle = {
    display: 'inline-block',
    marginTop: '30px',
    padding: '1rem 4%',
    fontSize: '16px',
    textDecoration: 'none',
    color: '#ffffff',
    backgroundColor: '#03236F',
    cursor: 'pointer',
    borderRadius: '10px',
    borderColor: 'transparent',
  };

  const hoverStyle = {
    backgroundColor: '#03236F',
    color: '#ffffff',
    transition: 'background-color 0.3s ease-in-out',
    borderColor: 'transparent',
  };

  const mergedStyle = { ...buttonStyle, ...extraStyle };

  const [style, setStyle] = React.useState(mergedStyle);

  const handleMouseOver = () => setStyle({ ...mergedStyle, ...hoverStyle });
  const handleMouseOut = () => setStyle(mergedStyle);

  return (
    <button
      type={type}
      style={style}
      onClick={onClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {children}
    </button>
  );
};

export default BlueButton;
